import React from "react";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import { Search } from "@styled-icons/boxicons-regular/Search";

const Control = props => {
  return (
    <components.Control {...props}>
      <div style={{ width: "100%", display: "flex", alignItems: "center", maxHeight: "150px", overflow: "auto" }}>
        {props.selectProps.isSearchable ? <Search style={{ width: "18px", margin: "0 0 0 10px" }} /> : null}
        {props.children}
      </div>
    </components.Control>
  );
};

const CustomSelect = props => {
  const customStyles = {
    container: base => ({
      ...base,
      width: "100%",
      maxWidth: "100%",
      minWidth: "50px",
      ...(props.style || {}),
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#7F65FF !important" : "white",
      color: state.isSelected ? "white !important" : "#7F65FF",
      width: "100%",
      fontSize: props.fontSize || 14,
      fontWeight: 600,
      padding: props.optionPadding || 10,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "var(--key-color-2)",
        color: "white",
      },
      "&:nth-of-type(even)": {
        backgroundColor: "var(--grey-5)",
        "&:hover": {
          backgroundColor: "var(--key-color-2)",
          color: "white",
        },
      },
    }),
    control: (base, state) => ({
      ...base,
      width: "100%",
      opacity: state.isDisabled ? 0.5 : 1,
      marginRight: 5,
      fontSize: props.fontSize || 14,
      display: "flex",
      borderColor: state.isFocused ? "var(--key-color-2)" : base.borderColor,
      borderRadius: 20,
      boxShadow: "none",
      "&:hover": {
        borderColor: "var(--key-color-2)",
      },
      // "@media (max-width: 768px)": {
      //   fontSize: 16,
      // },
    }),
    placeholder: base => ({
      ...base,
      color: "var(--grey)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),
    dropdownIndicator: () => ({
      cursor: "pointer",
      paddingRight: "8px",
      color: "7F65FF",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };
  if (props.isMulti) {
    customStyles.valueContainer = base => ({
      ...base,
      width: "100%",
      maxWidth: "100%",
      flexWrap: "wrap",
    });
  }
  if (props.error) {
    customStyles.control = base => ({
      ...base,
      borderColor: "var(--status-red)",
      backgroundColor: "rgba(255, 92, 80, 0.15)",
    });
  }

  const BaseSelect = props.isCreatable ? CreatableSelect : Select;
  return (
    <BaseSelect
      {...props}
      // @ts-ignore
      inputId={props.id}
      components={{ Control, Option: props.option || components.Option }}
      isSearchable={props.isSearchable}
      isDisabled={props.isDisabled}
      isMulti={props.isMulti}
      getOptionLabel={props.getOptionLabel}
      getOptionValue={option => option.value || option.id || `${option}`}
      defaultValue={props.defaultValue}
      placeholder={props.placeholder}
      value={props.value}
      onInputChange={inputValue => (inputValue.length <= 25 ? inputValue : inputValue.substr(0, 25))}
      onChange={props.onChange}
      options={props.options}
      styles={customStyles}
    ></BaseSelect>
  );
};

export default CustomSelect;
